import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-front">
          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
          <nav className={`nav ${isMobileMenuOpen ? "active" : ""}`}>
            <a
              href="#features"
              className="nav-item selected"
              onClick={handleNavClick}
            >
              About RIPE
            </a>
            <a href="#contact" className="nav-item" onClick={handleNavClick}>
              Contact
            </a>
          </nav>
          <div className="login-container">
            <a
              href="https://ripelogin-frontend.prouddesert-9ac7c828.centralus.azurecontainerapps.io"
              className="login-btn"
            >
              Customer Login
            </a>
            <a
              href="https://front-collebesx.orangemushroom-bd51b447.eastus.azurecontainerapps.io/login"
              className="login-btn collabex-btn"
            >
              CollabEX Login
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
